import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Collapse } from "react-collapse";

import { PAYMENT_LIST_DIALER_API } from "const/apiMethods";
import { checkPermissionsFor } from "store/storeHelpers";
import { withTranslation } from "hoc/WithTranslation";
import { Spacer } from "components/base/Spacer";
import { getISOTime, getDefaultDateRange } from "utils/helpers";
import m from "definedMessages";
import PaymentsListTable from "./PaymentsListTable";
import PaymentsSectionHeader from "components/Payments/PaymentsSectionHeader";
import CommonDateFilter from "components/Payments/CommonDateFilter";


const PaymentsListSection = ({
    paymentItems,
    paymentItemsLoading,
    currencyName,
    getPaymentList,
    permissions,

    formatMessage
}) => {
    const [showTable, setShowTable] = useState(true);

    const { start: dateStart, end: dateEnd } = useMemo(() => getDefaultDateRange(6), []);

    const [filters, setFilters] = useState({
        start_end_date: [dateStart, dateEnd]
    });

    useEffect(() => {
        if (!checkPermissionsFor(PAYMENT_LIST_DIALER_API)) {
            return;
        }

        getPaymentList({
            filter: {
                start_date: getISOTime(dateStart),
                end_date: getISOTime(dateEnd),
            },
        });
    }, [dateStart, dateEnd, getPaymentList, permissions]);

    const handleChangeFilters = useCallback((value) => {
        if (!value || !value.start_end_date || value.start_end_date.length < 2) {
            return;
        }

        setFilters({
            start_end_date: value.start_end_date
        });

        const startDate = new Date(value.start_end_date[0]);
        const endDate = new Date(value.start_end_date[1]);

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        getPaymentList({
            filter: {
                start_date: getISOTime(startDate),
                end_date: getISOTime(endDate),
                // start_end_date: value.start_end_date,
            },
        });
    }, [getPaymentList]);

    const toggleTable = useCallback(() => {
        setShowTable(prev => !prev);
    }, []);

    return (
        <>
            <PaymentsSectionHeader
                title={formatMessage(m.paymentList)}
                show={showTable}
                callback={toggleTable}
            />

            <Collapse isOpened={showTable}>
                <div>
                    <Spacer />

                    <CommonDateFilter
                        filters={filters}
                        onChangeFilters={handleChangeFilters}
                    />

                    <Spacer />

                    <PaymentsListTable
                        data={paymentItems}
                        loading={paymentItemsLoading}
                        currencyName={currencyName}
                    />
                </div>
            </Collapse>
        </>
    );
};

export default withTranslation(PaymentsListSection);
